import React from "react"
import Layout from "../components/layout"
import Helmet from "react-helmet"
import { Link } from "gatsby"

import style from "../components/services.module.scss"

import IdeaRefinement from "../assets/idea-refinement.inline.svg"
import FrontEnd from "../assets/front-end.inline.svg"
import BackEnd from "../assets/back-end.inline.svg"
import Mobile from "../assets/mobile-development.inline.svg"
import Iot from "../assets/iot.inline.svg"
import Enterprise from "../assets/enterprise.inline.svg"
import TeamAugmentation from "../assets/team-augmentation.inline.svg"
import SchemaComponent from "../components/schema-component"

export default () => (
  <Layout>
    <Helmet>
      <title>Services - Obicis</title>
      <meta
        name="description"
        content="Obicis offers a range of software development services, 
        including web frontend development, web backend development, 
        mobile apps, software for connected devices and IoT, enterprise 
        software, and team augmentation services."
      />
      <meta property="og:title" content="Services" />
      <meta property="og:url" content="https://www.obicis.com/services/" />
      <meta
        property="og:description"
        content="Obicis offers a range of software development services, 
        including web frontend development, web backend development, 
        mobile apps, software for connected devices and IoT, enterprise 
        software, and team augmentation services."
      />
    </Helmet>
    <SchemaComponent
      description="Obicis offers a range of software development services, 
      including web frontend development, web backend development, 
      mobile apps, software for connected devices and IoT, enterprise 
      software, and team augmentation services."
      breadcrumb={{
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Services",
            item: "https://www.obicis.com/services/",
          },
        ],
      }}
    />
    <div className={["services", style.services].join(" ")}>
      <div className={["service-wrapper", style.services].join(" ")}>
        <div className={["content", style.services].join(" ")}>
          <IdeaRefinement
            className={["section-img"].join(" ")}
            aria-label={"Idea refinement illustration"}
          />
          <h2>Idea Refinement</h2>
          Our experience will ensure a smooth ride on the journey from your idea
          to the end-product. We will develop it into the right product for the
          right users.
          {/* <div className={["divider"].join(" ")}></div> */}
        </div>
      </div>
      <div className={["service-wrapper", style.services].join(" ")}>
        <div className={["content", style.services].join(" ")}>
          <h2>Web Development</h2>
          <div>
            <FrontEnd
              className={["section-img"].join(" ")}
              aria-label={"Front-end illustration"}
            />
            <h4>Frontend Development</h4>
            Looking for someone to help turn your disruptive business idea into
            reality? By using JavaScript frameworks like React and Redux, we'll
            turn your idea into an engaging and lightning-fast solution.
            <div className={["subdivider"].join(" ")}></div>
          </div>
          <div>
            <BackEnd
              className={["section-img"].join(" ")}
              aria-label={"Back-end illustration"}
            />
            <h4>Backend Development</h4>
            In the search for a GraphQL service to feed the data to your next
            hit on the mobile app stores? Do you need the backend part for your
            future web app? Maybe you'd like to foster a thriving ecosystem
            around your app by having a scalable REST API for 3rd parties? Our
            expertise in scalable and performant technologies like Node.js,
            Java, and Spring will let us craft the best solution for your needs.
          </div>
          {/* <div className={["divider"].join(" ")}></div> */}
        </div>
      </div>
      <div className={["service-wrapper", style.services].join(" ")}>
        <div className={["content", style.services].join(" ")}>
          <Mobile
            className={["section-img"].join(" ")}
            aria-label={"Phone and tablet illustration"}
          />
          <h2>Mobile Development</h2>
          Whether you're looking to build a revolutionary app in your industry
          or you want to make interacting with your customers easier (and
          everything in-between), we've got you covered. On Android and Apple.
          {/* <div className={["divider"].join(" ")}></div> */}
        </div>
      </div>
      <div className={["service-wrapper", style.services].join(" ")}>
        <div className={["content", style.services].join(" ")}>
          <Iot
            className={["section-img"].join(" ")}
            aria-label={
              "Connected car with connected coffee maker illustration"
            }
          />
          <h2>Connected Devices - IoT</h2>
          As its name suggests, a connected device needs to connect to
          something. Whether you're creating a smart coffee machine, a connected
          vehicle, or a combination of both, we will build the backend for your
          devices to connect to and the frontend for clients to interact with
          them, e.g., to control them or analyze reports.
          {/* <div className={["divider"].join(" ")}></div> */}
        </div>
      </div>
      <div className={["service-wrapper", style.services].join(" ")}>
        <div className={["content", style.services].join(" ")}>
          <Enterprise
            className={["section-img"].join(" ")}
            aria-label={"Server room illustration"}
          />
          <h2>Enterprise Software</h2>
          Enterprise software often requires some specific steps. We have
          experience building software that interoperates with legacy enterprise
          systems and systems from other vendors using a wide array of
          communication technologies (REST, SOAP, messaging) as well as
          deploying in-house iOS enterprise applications outside of app stores.
          {/* <div className={["divider"].join(" ")}></div> */}
        </div>
      </div>
      <div className={["service-wrapper", style.services].join(" ")}>
        <div className={["content", style.services].join(" ")}>
          <TeamAugmentation
            className={["section-img"].join(" ")}
            aria-label={"Team augmentation illustration"}
          />
          <h2>Team augmentation</h2>
          Whether you got a project that requires more people or you temporarily
          need an expert in a particular field, even the most capable teams can
          sometimes use an extra pair of hands. We offer experienced JavaScript,
          Java, and Objective-C developers for your project. Our developers are
          well-versed in specific frameworks and libraries like React, Node.js,
          Spring, Leaflet.js, Redux, and GraphQL, as well as various data stores
          and message brokers. Our developers have experience working in
          SAFe-agile multi-site teams on large international projects.
          {/* <div className={["divider"].join(" ")}></div> */}
        </div>
      </div>
      <div className={["link-more", style.more].join(" ")}>
        <Link to="/contact/">Contact Us</Link>
      </div>
    </div>
  </Layout>
)
